import type { SnapshotDrillId } from "@healthos/shared";
import {
  CirclesThree,
  Heartbeat,
  Lightning,
  Moon,
  Person,
  type Icon as PhosphorIcon,
  PlugsConnected,
} from "@phosphor-icons/react";

export type SnapshotTab = "overview" | SnapshotDrillId | "sources";

export const SNAPSHOT_TABS: ReadonlyArray<{ id: SnapshotTab; label: string; Icon: PhosphorIcon }> =
  [
    { id: "overview", label: "Overview", Icon: CirclesThree },
    { id: "sleep", label: "Sleep", Icon: Moon },
    { id: "recovery", label: "Recovery", Icon: Heartbeat },
    { id: "strain", label: "Strain", Icon: Lightning },
    { id: "body", label: "Body", Icon: Person },
    { id: "sources", label: "Sources", Icon: PlugsConnected },
  ];

export function SnapshotTabs({
  value,
  onChange,
  onExplain,
}: {
  value: SnapshotTab;
  onChange: (next: SnapshotTab) => void;
  /** Reopens the walkthrough. It runs once on a first visit and is dismissed for good. */
  onExplain?: () => void;
}) {
  return (
    <nav className="snap-tabs" aria-label="Snapshot sections">
      {SNAPSHOT_TABS.map(({ id, label, Icon }) => (
        <button key={id} type="button" aria-pressed={value === id} onClick={() => onChange(id)}>
          <Icon size={13} aria-hidden="true" />
          {label}
        </button>
      ))}
      {onExplain ? (
        <button className="snap-tabs-explain" type="button" onClick={onExplain}>
          How to read this
        </button>
      ) : null}
    </nav>
  );
}
